export default {
    code: 'FORMULA_1_GLOBAL',
    content: {
        transaction: {
            items: [
                'hideGoBackButton',
            ]
        },
        signIn: {
            individual: {
                backgroundImage: 'url(https://res.cloudinary.com/carbonclick/image/upload/v1677487084/F1/F1-TransactionPage-Background_uhqo3q.png)',
            }
        },
        logo: {
            link: 'https://traveloffset.formula1.com/'
        }
    },
    theme: {
        images: {
            hero: {
                main: 'url(\'https://res.cloudinary.com/carbonclick/image/upload/v1677487084/F1/F1-TransactionPage-Background_uhqo3q.png\')',
            },
        }
    },
    hideMentionsOfCarbonClick: true
}